import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LoginForm.module.css';

function LoginForm() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null); // For displaying errors

  const handleLogin = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch('http://localhost:8080/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.error || 'Login failed. Please try again.');
        return;
      }

      const { token } = await response.json();
      const payload = JSON.parse(atob(token.split('.')[1])); // Decode JWT payload

      // Save the token in localStorage (optional for persistence)
      localStorage.setItem('authToken', token);

      // Navigate based on userType
      switch (payload.userType) {
        case 'worker':
          navigate('/worker');
          break;
        case 'manager':
          navigate('/factory-manager');
          break;
        case 'sales':
          navigate('/sales');
          break;
        case 'admin':
          navigate('/company-manager');
          break;
        default:
          setErrorMessage('Invalid user type.');
      }
    } catch (error) {
      console.error('Error during login:', error);
      setErrorMessage('An error occurred. Please try again.');
    }
  };

  return (
    <section className={styles.loginSection}>
      <div className={styles.formContainer}>
        <h2 className={styles.formTitle}>Login</h2>
        <p className={styles.formDescription}>Enter your username and password below</p>
        
        <form className={styles.form} onSubmit={handleLogin}>
          <div className={styles.inputGroup}>
            <label htmlFor="username" className={styles.label}>Username</label>
            <input
              type="text"
              id="username"
              className={styles.input}
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>Password</label>
            <input
              type="password"
              id="password"
              className={styles.input}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className={styles.submitButton}>Login</button>
        </form>

        {errorMessage && (
          <div className={styles.errorModal}>
            <p>{errorMessage}</p>
            <button onClick={() => setErrorMessage(null)} className={styles.modalCloseButton}>
              Close
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default LoginForm;
